import { EditorialQuestion, editorialQuestionClient } from 'api/editorialQuestion';

let inFlight: Promise<EditorialQuestion> | null = null;

/** Click-time dummy create. Concurrent callers share one add_math_question. */
export function createNewQuestionDraft(): Promise<EditorialQuestion> {
  if (!inFlight) {
    const created = editorialQuestionClient.createDraft().finally(() => {
      if (inFlight === created) {
        inFlight = null;
      }
    });
    inFlight = created;
  }
  return inFlight;
}

export function resetCreateNewQuestionDraft(): void {
  inFlight = null;
}
